import React, { FC } from 'react';

import { Flex, Text } from '@rover/kibble/core';
import { useTheme } from '@rover/kibble/themes';

type Props = {
  unreadCountDisplay?: string;
  implementDjangoHacks: boolean;
  dataTestId?: string;
};

const NotificationsCenterCounter: FC<Props> = ({
  unreadCountDisplay,
  implementDjangoHacks,
  dataTestId,
}) => {
  const theme = useTheme();

  return (
    <Flex
      data-testid={dataTestId || 'notifications-center-counter'}
      backgroundColor={theme.background.interactive.destructive_base.toString()}
      borderRadius="round"
      justifyContent="center"
      alignItems="center"
      position="absolute"
      top="0"
      right="0"
      height="16px"
      minWidth="16px"
      padding="1x"
      sx={{
        transform: implementDjangoHacks
          ? ['translate(0)', 'translate(50%, -50%)']
          : ['translate(0)', 'translate(0)', 'translate(50%, -50%)'],
      }}
    >
      <Text
        size="50"
        fontWeight="semibold"
        textAlign="center"
        color={theme.textColor.primary_inverse.toString()}
      >
        {unreadCountDisplay}
      </Text>
    </Flex>
  );
};

export default NotificationsCenterCounter;
